import { useEffect, useState } from "react";
import formatCurrency from "../../../../Utils/formatCurrency";
import styles from "./InfoTour.module.css"
import { useNavigate } from "react-router-dom";
function InfoTour({ amount, image, name, time, link, accept_description, date_start }) {
    const navigate = useNavigate();

    const formatTime = (time) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const [timeFacts, setTimeFacts] = useState(time);
    const [timeStart, setTimeStart] = useState(date_start);
    const [statusEnter, setStatusEnter] = useState(false);
    useEffect(() => {

        const interval = setInterval(() => {
            setTimeStart(prev => prev - 1);
            setTimeFacts(prev => prev - 1);

        }, 1000)
        return () => clearInterval(interval);
    }, [])
    const isPhone = document.documentElement.clientWidth <= 1200;

    return (

        <div className={`${styles.blockTour}`} onClick={() => {
            if (timeStart < 0) {
                navigate(link)
            }

        }} onMouseEnter={() => setStatusEnter(true)

        } onMouseLeave={() => setStatusEnter(false)}>

            <div className={styles.gamecard_window}>
                {/* <div className={styles.top}>
                    <div>



                        <div className={`${styles.amount} skeleton-button`}>
                            <div className={styles.info_prize}>Призовой фонд</div>

                            {formatCurrency(amount, "cost")}
                        </div>


                    </div>

                </div> */}
                {/* {!isPhone && <div className={`${styles.buttonPlay} wallet_nav_bar`} style={{ opacity: statusEnter ? 1 : 0.9 }}>Участвовать</div>} */}

                <img src={image} />

            </div>
            <div className={styles.containerInformation}>

                <div className={styles.header} dangerouslySetInnerHTML={{ __html: name }}></div>
                <div className={`${styles.amount} skeleton-button`} style={{ marginBottom: "10px" }}>
                    <div className={styles.info_prize}>Призовой фонд</div>

                    {formatCurrency(amount, "cost")}
                </div>
                <div className={styles.blocksInf}>
                    {timeStart < 0 ?
                        <>
                            <div className={styles.blockInf}>
                                <div className={styles.headerSmall}>{timeFacts < 0 ? "Турнир завершен" : "До окончания турнира"}</div>
                                {timeFacts > 0 && <p className={styles.timeReg}>{formatTime(timeFacts)}</p>}

                            </div>
                            <div className={styles.blockInf}>
                                <div className={styles.headerSmall}>Доступ</div>
                                <p className={styles.info} dangerouslySetInnerHTML={{ __html: accept_description }}></p>

                            </div>
                            {timeFacts>0&&<div className={`${styles.buttonPlay} wallet_nav_bar skeleton-button`}>Участвовать</div>}
                        </>
                        : <>
                            <div className={styles.blockInf}>
                                <div className={styles.headerSmall}>До начала турнира</div>
                                <p className={styles.timeReg}>{formatTime(timeStart)}</p>

                            </div>
                            <div className={styles.blockInf}>
                                <div className={styles.headerSmall}>Доступ</div>
                                <p className={styles.info} dangerouslySetInnerHTML={{ __html: accept_description }}></p>

                            </div>

                        </>}


                </div>





            </div>

        </div>


    )
}
export default InfoTour;